export const FACULTY_IMAGES = {
  Sketches: [
    // { url: "/assets/imgs/gallery/sketch/eye.jpeg", title: "Expressive Eye Study", year: "2022" },
    // { url: "/assets/imgs/gallery/sketch/hand_on_head.jpeg", title: "Contemplation", year: "2021" },
    // { url: "/assets/imgs/gallery/sketch/hat_baby.jpeg", title: "Child with Hat", year: "2023" },
    // { url: "/assets/imgs/gallery/sketch/magician.jpeg", title: "The Magician", year: "2020" },
    // { url: "/assets/imgs/gallery/sketch/man_1.jpeg", title: "Portrait Study I", year: "2021" },
    // { url: "/assets/imgs/gallery/sketch/nana_patekar.jpeg", title: "Nana Patekar Portrait", year: "2022" },
    { url: "/assets/imgs/gallery/sketch/lady_1.jpeg", title: "Graceful Lady", year: "2020" },
    // { url: "/assets/imgs/gallery/sketch/lady_pencil.jpeg", title: "Pensive Woman", year: "2021" },
    // { url: "/assets/imgs/gallery/sketch/girl_1.jpeg", title: "Young Girl Sketch", year: "2022" },
    { url: "/assets/imgs/gallery/sketch/cigar_man.jpeg", title: "Man with Cigar", year: "2023" },
    { url: "/assets/imgs/gallery/sketch/durga_sketch.jpeg", title: "Durga Sketch", year: "2019" },
    { url: "/assets/imgs/gallery/sketch/gandhi_sketch.jpeg", title: "Mahatma Gandhi Sketch", year: "2018" },
    { url: "/assets/imgs/gallery/sketch/lata_sketch.jpeg", title: "Lata Mangeshkar Tribute", year: "2022" },
    // { url: "/assets/imgs/gallery/sketch/girl_1_pencil.jpeg", title: "Innocence", year: "2023" },
    { url: "/assets/imgs/gallery/sketch/boy_sketch.jpeg", title: "Boy Sketch", year: "2018" },
    { url: "/assets/imgs/gallery/sketch/girl_sketch.jpeg", title: "", year: "2022" },
    { url: "/assets/imgs/gallery/sketch/old_man_sketch.jpeg", title: "Old man", year: "2023" },
  ],

  Watercolor: [
    { url: "/assets/imgs/gallery/waterColor/girl_watercolor.jpeg", title: "Girl", year: "2021" },
    { url: "/assets/imgs/gallery/waterColor/sadhu-1.jpeg", title: "", year: "2020" },
    { url: "/assets/imgs/gallery/waterColor/village-1.jpg", title: "Soft Wash Study", year: "2022" },
    { url: "/assets/imgs/gallery/waterColor/village-2.jpg", title: "Village study", year: "2021" },
    { url: "/assets/imgs/gallery/waterColor/village-wc.jpeg", title: "Light & Shadow", year: "2023" },
    { url: "/assets/imgs/gallery/waterColor/village-wc1.jpeg", title: "Lady", year: "2022" },
    { url: "/assets/imgs/gallery/waterColor/wc-sadhu.jpeg", title: "Monk", year: "2023" },
    { url: "/assets/imgs/gallery/waterColor/wcsadhu.jpeg", title: "Sadhu", year: "2020" },
    { url: "/assets/imgs/gallery/waterColor/girl_portrait_wc.jpeg", title: "Girl", year: "2022" },
    { url: "/assets/imgs/gallery/waterColor/hat_man_wc.jpeg", title: "Man with hat", year: "2021" },
    { url: "/assets/imgs/gallery/waterColor/boat_wc.jpeg", title: "Boat scenery", year: "2023" },
    { url: "/assets/imgs/gallery/waterColor/collage-wcportrait.jpeg", title: "Collage", year: "2022" },
    { url: "/assets/imgs/gallery/waterColor/girl_watercolor.jpeg", title: "Indian Woman", year: "2023" },
    // { url: "/assets/imgs/gallery/waterColor/old_man_watercolor.jpeg", title: "Wisdom", year: "2022" },
    // { url: "/assets/imgs/gallery/waterColor/land_1_water.jpeg", title: "Landscape I", year: "2020" },
    // { url: "/assets/imgs/gallery/waterColor/land_2_water.jpeg", title: "Landscape II", year: "2021" },
    // { url: "/assets/imgs/gallery/waterColor/land_3_water.jpeg", title: "Landscape III", year: "2022" },
    // { url: "/assets/imgs/gallery/waterColor/land_4_water.jpeg", title: "Landscape IV", year: "2023" },
    // { url: "/assets/imgs/gallery/waterColor/land_5_water.jpeg", title: "Landscape V", year: "2021" },
    // { url: "/assets/imgs/gallery/waterColor/land_7_color.jpeg", title: "Golden Fields", year: "2022" },
    // { url: "/assets/imgs/gallery/waterColor/village_water_color.jpeg", title: "Village Life", year: "2023" },
  ],

  Oil: [
    { url: "/assets/imgs/gallery/oil/bride_oil.jpeg", title: "Indian Bride", year: "2022" },
    { url: "/assets/imgs/gallery/oil/girl_oil.jpeg", title: "Girl in Thought", year: "2021" },
    { url: "/assets/imgs/gallery/oil/horse_oil.jpeg", title: "Galloping Horse", year: "2020" },
    { url: "/assets/imgs/gallery/oil/fall_oil.jpeg", title: "Fall color", year: "2020" },
    { url: "/assets/imgs/gallery/oil/oil-2.jpeg", title: "Oil Study II", year: "2020" },
    { url: "/assets/imgs/gallery/oil/oil-3.jpeg", title: "Oil Study III", year: "2021" },
    { url: "/assets/imgs/gallery/oil/oil-4.jpeg", title: "Oil Study IV", year: "2022" },
    { url: "/assets/imgs/gallery/oil/oil-5.jpeg", title: "Oil Study V", year: "2023" },
    { url: "/assets/imgs/gallery/oil/landscape_1_oil.jpeg", title: "Oil Study VI", year: "2021" },
    { url: "/assets/imgs/gallery/oil/landscape_oil.jpeg", title: "Still Life Composition", year: "2022" },
    { url: "/assets/imgs/gallery/oil/oil_landscape.jpeg", title: "Village in Oil", year: "2023" },
    { url: "/assets/imgs/gallery/oil/stilllife_oil.jpeg", title: "Mountain Landscape", year: "2021" },
  ],

  Acrylic: [
    { url: "/assets/imgs/gallery/acrylic/buddha.jpeg", title: "Serene Buddha", year: "2022" },
    { url: "/assets/imgs/gallery/acrylic/fall_acrylic.jpeg", title: "Autumn Leaves", year: "2020" },
    { url: "/assets/imgs/gallery/acrylic/acrylic-ganesh.jpeg", title: "Lord Ganesha", year: "2021" },
    { url: "/assets/imgs/gallery/acrylic/acrylic-girl.jpeg", title: "Dreamer", year: "2022" },
    { url: "/assets/imgs/gallery/acrylic/acrylic-flower.jpeg", title: "Red Blossom", year: "2023" },
    { url: "/assets/imgs/gallery/acrylic/acrylic-flower1.jpeg", title: "Spring Petals", year: "2022" },
    { url: "/assets/imgs/gallery/acrylic/anupam_acrylic.jpeg", title: "Anupam Roy", year: "2021" },
    { url: "/assets/imgs/gallery/acrylic/durga_acrylic.jpeg", title: "Maa Durga", year: "2023" },
    { url: "/assets/imgs/gallery/acrylic/landscape-acrylic.jpeg", title: "Night Reflections", year: "2022" },
  ],

  Pastel: [
    // { url: "/assets/imgs/gallery/pastel/lady_pastel.jpeg", title: "Pastel Portrait", year: "2022" },
    // { url: "/assets/imgs/gallery/pastel/landscape_1_pastel.jpeg", title: "Pastel Landscape I", year: "2021" },
    // { url: "/assets/imgs/gallery/pastel/land_8_oil_pastel.jpeg", title: "Golden Horizon", year: "2023" },
    { url: "/assets/imgs/gallery/pastel/butterfly_oil_pastel.jpeg", title: "Butterfly Dream", year: "2022" },
    { url: "/assets/imgs/gallery/waterColor/kajol_water.jpeg", title: "Kajol Portrait", year: "2021" },
  ],
  Pencil: [
    { url: "/assets/imgs/gallery/color-pencil/eye.jpeg", title: "Color Pencil Study I", year: "2022" },
    { url: "/assets/imgs/gallery/color-pencil/kid-colorpencil.jpeg", title: "Color Pencil Study II", year: "2021" },
    { url: "/assets/imgs/gallery/color-pencil/meye.jpeg", title: "Color Pencil Study III", year: "2023" },
    { url: "/assets/imgs/gallery/color-pencil/oldlady-prismacolor.jpeg", title: "Color Pencil Study IV", year: "2022" },
  ]
};

export const STUDENT_IMAGES = [
  "/assets/imgs/gallery/studentArt/s-art-192.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-195.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-196.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-197.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-198.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-202.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-203.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-204.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-206.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-207.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-208.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-209.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-210.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-211.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-212.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-214.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-215.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-216.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-217.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-218.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-220.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-221.jpeg",
  "/assets/imgs/gallery/studentArt/s-art-222.jpeg",
];

export const FACULTY_DATA = [
  {
    url: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5",
    title: "The Silent Bloom",
    artist: "Prof. Elena Rossi",
    role: "Head of Fine Arts",
    education: "MFA, Florence Academy of Art",
    experience: "15+ Years",
    bio: "Prof. Rossi specializes in 19th-century oil techniques. Her work has been exhibited in Rome, Paris, and New York. She believes that mastering classical foundations is the key to modern creative freedom.",
    medium: "Oil on Linen",
    year: "2023"
  },
  {
    url: "https://images.unsplash.com/photo-1513364776144-60967b0f800f",
    title: "Abstract Rhythm No. 4",
    artist: "Dr. Marcus Vane",
    role: "Senior Instructor - Modern Art",
    education: "PhD in Visual Arts, Yale",
    experience: "10 Years",
    bio: "Dr. Vane explores the intersection of digital technology and traditional acrylics. His curriculum focuses on color theory and emotional resonance in abstract composition.",
    medium: "Mixed Media",
    year: "2024"
  }
];